import React from 'react';
import { ArrowRight, Phone } from 'lucide-react';
export function FinalCTA() {
  return <section className="py-24 bg-primary-600 relative overflow-hidden" data-id="element-512">
      {/* Background Pattern */}
      <div className="absolute inset-0 bg-glass-grid opacity-20 pointer-events-none mix-blend-overlay" data-id="element-513"></div>
      <div className="max-w-4xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10 text-center anim-on-scroll" data-id="element-514">
        <h2 className="kosins-heading text-4xl md:text-6xl text-white mb-6" data-id="element-515">
          Need Commercial Glass Repaired, Replaced or Installed?
        </h2>
        <p className="text-xl text-primary-100 mb-6 leading-relaxed" data-id="element-516">
          Whether you need storefront glass repair, commercial window
          replacement, office glass walls or a full contract glazing bid,
          Kosin’s Glass can help you get clear next steps and a professional
          commercial glass estimate.
        </p>

        {/* Trust line */}
        <div className="inline-flex flex-wrap items-center justify-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 rounded-full px-4 py-2 mb-8" aria-label="5-star trusted service" data-id="element-517">
          <span className="flex items-center gap-0.5 text-amber-300" aria-hidden="true" data-id="element-518">
            {[0, 1, 2, 3, 4].map(i => <svg key={i} className="w-3.5 h-3.5 fill-current" viewBox="0 0 20 20" data-id="element-519">
                <path d="M10 1.5l2.6 5.3 5.9.9-4.3 4.1 1 5.8L10 14.9 4.8 17.6l1-5.8L1.5 7.7l5.9-.9z" data-id="element-520" />
              </svg>)}
          </span>
          <span className="text-sm text-white font-medium font-sans" data-id="element-521">
            Trusted by Michigan businesses, builders and property managers for
            commercial glass repair, replacement and glazing.
          </span>
        </div>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4" data-id="element-522">
          <a href="#quote-form" className="w-full sm:w-auto bg-white text-primary-700 font-bold py-4 px-8 rounded-lg hover:bg-slate-50 transition-colors flex items-center justify-center gap-2 group" data-id="element-523">
            Request a Free Commercial Estimate
            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" data-id="element-524" />
          </a>
          <a href="tel:5175457772" className="w-full sm:w-auto bg-primary-700 text-white font-bold py-4 px-8 rounded-lg hover:bg-primary-800 transition-colors flex items-center justify-center gap-2 border border-primary-500" data-id="element-525">
            <Phone className="w-5 h-5" data-id="element-526" />
            Call 517-545-7772
          </a>
        </div>
      </div>
    </section>;
}